import {getRestfulData} from "./Common";

export async function getPosProducts({page, sortOrder, sortColumn}){
    return getRestfulData({
        url: `common/product?p=${page}&s=${sortColumn || ''}&o=${sortOrder || ''}`
    });
}